import is from "./is";

const isFn = is(Function);
export default isFn;
